import { Box, Container, Grid, Typography } from '@mui/material';
import { ActionCreatorWithPayload } from '@reduxjs/toolkit';
import React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { Observable } from 'rxjs';

import { RequestCards } from 'app/components/request-cards';
import { GeneralConstants } from 'app/constants';
import { SeamStatus } from 'app/constants/seam-status';
import { SeamRequest } from 'app/model/seam-request';
import { SeamRequestFilter } from 'app/model/seam-request-filter';

import { fetchSeamRequests, selectRequest } from './slice';

const COLUMNS = [
    {
        header: 'For Assignment',
        statuses: [SeamStatus.ASSIGN],
    },
    {
        header: 'In-Progress',
        statuses: [SeamStatus.TUNE, SeamStatus.LABEL],
    },
    {
        header: 'For Review',
        statuses: [SeamStatus.REVIEW],
    },
    {
        header: 'Preprod QA',
        statuses: [SeamStatus.QA, SeamStatus.PREPROD],
    },
    {
        header: 'Prod QA',
        statuses: [SeamStatus.PROD, SeamStatus.PROD_QA],
    },
];

interface KanbanProps extends RouteComponentProps {
    fetchSeamRequests: (filter: SeamRequestFilter) => Observable<SeamRequest[]>;
    selectRequest: (request: SeamRequest) => void;
}

interface KanbanState {
    requests: SeamRequest[][];
}

class Kanban extends React.Component<KanbanProps, KanbanState> {
    public constructor(props: KanbanProps | Readonly<KanbanProps>) {
        super(props);

        this.state = {
            requests: COLUMNS.map(() => [] as SeamRequest[]),
        };
    }

    public componentDidMount() {
        COLUMNS.forEach((column, index) => {
            this.props.fetchSeamRequests({ status: column.statuses }).subscribe((requests) => {
                const newRequests = this.state.requests;
                newRequests[index] = requests;
                this.setState({ requests: newRequests });
            });
        });
    }

    public render() {
        return (
            <Container maxWidth={false} className='mt-3'>
                <Box sx={{ overflowX: 'auto', width: '100%' }}>
                    <Grid
                        container
                        spacing={2}
                        style={{ display: 'flex', width: `${GeneralConstants.COLUMN_WIDHT_EM * COLUMNS.length}em` }}
                    >
                        {COLUMNS.map((column, index) => (
                            <Grid
                                item
                                style={{ flex: `0 0 ${GeneralConstants.COLUMN_WIDHT_EM}em` }}
                                key={column.header}
                            >
                                <Typography
                                    className='p-1'
                                    sx={{ backgroundColor: 'success.light', textAlign: 'center' }}
                                >
                                    {column.header}
                                </Typography>
                                <Box
                                    sx={{
                                        backgroundColor: 'lightgray',
                                        height: 'calc(100vh - 64px)',
                                        overflowY: 'auto',
                                    }}
                                >
                                    <RequestCards
                                        requests={this.state.requests[index]}
                                        onSelect={(request: SeamRequest) => this.openRequest(request)}
                                        cardClass='mb-1'
                                    />
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </Container>
        );
    }

    private openRequest(request: SeamRequest) {
        this.props.selectRequest(request);
        this.props.history.push(`/seam/request/${request.id || ''}`);
    }
}

const connected = connect(undefined, {
    fetchSeamRequests,
    selectRequest: selectRequest as ActionCreatorWithPayload<SeamRequest>,
})(withRouter(Kanban));

export { connected as Kanban };
